export const arrayToString = (entry, separator = ', ') => (Array.isArray(entry) ? entry.join(separator) : entry);

export const stringToArray = (entry, separator = ' ') => (typeof entry === 'string' ? entry.split(separator) : entry);

export const flattenNestedArrays = entry => entry.reduce((acc, list) => [
    ...acc,
    ...list
], []);
